import I18n from 'components/I18n'
import Chevron, { ChevronDirection } from 'components/Icons/Chevron'
import Tag, { TagTheme, TagType } from 'components/Tag'
import Text from 'components/Text'
import React from 'react'
import { MessageDescriptor } from 'react-intl'
import styled from 'styled-components'

import RowIcon from './RowIcon'
import { Body, Right, Row } from './Rows.styles'

type TagItemType = {
  component?: React.ReactNode
  copy?: MessageDescriptor
  key: string
  type: TagType
}

export type RowItemType = {
  label?: string
  onClick: () => void
  symbol?: string | undefined
  tags?: TagItemType[]
  tight?: boolean
  title?: string
  tooltip?: string
  tooltipProps?: unknown
  type: string
}

type RowsPropsType = {
  className?: string
  rows: RowItemType[]
}

const Tags = styled.div`
  margin-top: 2px;
`

const Rows = ({ className, rows }: RowsPropsType) => (
  <div className={className}>
    {rows.map(({ label, onClick, symbol, tags, tight = false, title, type }) => (
      <Row key={symbol} onClick={onClick} tight={tight}>
        <Right>
          <RowIcon type={type} symbol={symbol} />
          <Body>
            <Text color='white'>{title}</Text>
            <Text color='dark200' size='sm'>
              {label ?? symbol}
            </Text>
            {tags && (
              <Tags>
                {tags.map((tagItem: TagItemType) => (
                  <Tag key={tagItem.key} type={tagItem.type} theme={TagTheme.DARK}>
                    {tagItem.copy && <I18n data={tagItem.copy} />}
                    {/* @ts-ignore FIXME fix typing issues with dinamyc component */}
                    {tagItem.component && <tagItem.component />}
                  </Tag>
                ))}
              </Tags>
            )}
          </Body>
        </Right>
        <Chevron direction={ChevronDirection.Right} size={32} />
      </Row>
    ))}
  </div>
)

export default Rows
